export function getCuratedListCover(list) {
    const uploaded = list?.uploadedCoverImageUrl || list?.coverUploadUrl;
    const manual = list?.coverImageUrl || list?.cover_image_url;
    const url = uploaded || manual || null;

    return {
        url,
        source: uploaded ? 'upload' : (url ? (list?.coverImageSource || 'url') : null),
        alt: `${list?.title || 'Curated list'} cover`,
    };
}
